module.exports = __webpack_public_path__ + "static/img/btn_qiandao_nor.52cad8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_qiandao_nor.png
// module id = q0mQ
// module chunks = 1